import { MenuNavigationItem } from './MenuNavigationItem';
import { MenuNavigationRoot } from './MenuNavigationRoot';

export const MenuNavigation = {
  Root: MenuNavigationRoot,
  Item: MenuNavigationItem,
};
